import type { RoomLine } from '../api';

const lastSeq = (lines: RoomLine[]): number => (lines.length ? lines[lines.length - 1].seq : 0);

/**
 * The server's list of a room's lines is the truth: a line it no longer carries
 * (taken down by Ember, deleted by its author, hidden after a report) leaves the
 * page. The one thing kept from the page is a line newer than anything the
 * server had when it answered — the viewer's own, just sent, or one that came
 * in over Stream while the page was being re-read (room-stream.ts).
 */
export function mergeLines(here: RoomLine[], server: RoomLine[]): RoomLine[] {
  const newest = lastSeq(server);
  return [...server, ...here.filter((l) => l.seq > newest)];
}
